import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

interface StoreReviewState {
  metrics: {
    affiliate: boolean
    explore: boolean
    manage: boolean
    billing: boolean
    profile: boolean
  }
  setMetrics: (data: {
    affiliate: boolean
    explore: boolean
    manage: boolean
    billing: boolean
    profile: boolean
  }) => void
  isReview: boolean
  setIsReview: (isReview: boolean) => void
  reset: () => void
}

export const useStoreReview = create<StoreReviewState>()(
  persist(
    (set) => ({
      metrics: {
        affiliate: false,
        explore: false,
        manage: false,
        billing: false,
        profile: false
      },
      isReview: false,
      setMetrics: (data) => {
        set((state) => {
          return {
            metrics: {
              affiliate: data.affiliate || state.metrics.affiliate,
              explore: data.explore || state.metrics.explore,
              manage: data.manage || state.metrics.manage,
              billing: data.billing || state.metrics.billing,
              profile: data.profile || state.metrics.profile
            }
          }
        })
      },
      setIsReview: (isReview) => {
        set({ isReview })
      },
      reset: () => {
        set({
          isReview: false,
          metrics: {
            affiliate: false,
            explore: false,
            manage: false,
            billing: false,
            profile: false
          }
        })
      }
    }),
    {
      name: "track-storage",
      storage: createJSONStorage(() => window.localStorage)
    }
  )
)
